import { z } from 'zod';

// Setter §09.4: structured objections captured by the agent (`record_objection`, WhatsApp + voice) on the opportunity
// (contact + project). Categories follow §09.4 («información insuficiente, precio, ubicación, tiempo, forma de pago o
// necesidad de consultar a otra persona») plus the commercial ones the team tracks.

const Id = z.string().min(1);
const Iso = z.string();

export const OBJECTION_CATEGORIES = [
  'precio',
  'ubicacion',
  'financiamiento',
  'tiempo_entrega',
  'confianza',
  'tamano_distribucion',
  'informacion',
  'consultar_otra_persona',
  'otra',
] as const;
export const ObjectionCategorySchema = z.enum(OBJECTION_CATEGORIES);
export type ObjectionCategory = z.infer<typeof ObjectionCategorySchema>;
export const OBJECTION_CATEGORY_LABELS: Record<ObjectionCategory, string> = {
  precio: 'Precio',
  ubicacion: 'Ubicación',
  financiamiento: 'Financiamiento / forma de pago',
  tiempo_entrega: 'Tiempo de entrega',
  confianza: 'Confianza',
  tamano_distribucion: 'Tamaño / distribución',
  informacion: 'Información insuficiente',
  consultar_otra_persona: 'Consultar con otra persona',
  otra: 'Otra',
};

export const OBJECTION_STATUSES = ['open', 'addressed', 'resolved'] as const;
export const ObjectionStatusSchema = z.enum(OBJECTION_STATUSES);
export type ObjectionStatus = z.infer<typeof ObjectionStatusSchema>;
export const OBJECTION_STATUS_LABELS: Record<ObjectionStatus, string> = {
  open: 'Abierta',
  addressed: 'Atendida',
  resolved: 'Resuelta',
};

export const OpportunityObjectionSchema = z.object({
  id: Id,
  category: ObjectionCategorySchema,
  categoryLabel: z.string(),
  /** The prospect's words, short. */
  prospectWords: z.string(),
  status: ObjectionStatusSchema,
  handledWith: z.string().nullable(),
  knowledgeRef: z.string().nullable(),
  channel: z.enum(['whatsapp', 'voice']),
  source: z.enum(['ai', 'human']),
  createdAt: Iso,
  updatedAt: Iso,
  addressedAt: Iso.nullable(),
  resolvedAt: Iso.nullable(),
});
export type OpportunityObjection = z.infer<typeof OpportunityObjectionSchema>;

export const LeadObjectionsSchema = z.object({
  interestId: Id,
  objections: z.array(OpportunityObjectionSchema),
});
export type LeadObjections = z.infer<typeof LeadObjectionsSchema>;
